module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-blue-2f8468.svg";